<template>
  <form @submit.prevent="submit" class="product-checkout-form-buy mt-9 mt-lg-0">
    <div class="my-5">Opções do formulário</div>

    <bp-checkbox-group v-model="values" :options="options" />

    <div
      class="d-flex flex-column-reverse gap-5 flex-md-row justify-content-between mt-6"
    >
      <bp-button
        label="Voltar"
        color="neutral"
        icon="icon-angle-left"
        variant="filled-1"
        @click="$emit('cancel')"
      />

      <bp-button
        color="primary"
        trailingIcon="icon-angle-right"
        label="Próximo"
        @click="submit"
      />
    </div>
  </form>
</template>

<script>
export default {
  props: {
    optionForm: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      values: [
        ...Object.entries(this.optionForm).reduce((acc, [key, value]) => {
          if (value) {
            acc.push(key);
          }
          return acc;
        }, [])
      ],
      options: [
        {
          id: "request_address_shopper",
          name: "Solicitar endereço do comprador"
        },
        {
          id: "request_cpf_cnpj_shopper",
          name: "Solicitar CPF/CNPJ do comprador",
          hide: true
        },
        {
          id: "request_phone_shopper",
          name: "Solicitar telefone do comprador"
        },
        {
          id: "coupon_shopper",
          name: "Solicitar cupom do comprador",
          hide: true
        },
        {
          id: "instagram_shopper",
          name: "Solicitar usuário do Instagram do comprador",
          description: "(Recomendado para produtos vendidos pelo instagram)"
        },
        {
          id: "request_zip_code",
          name: "Exigir que o endereço seja preenchido somente com base no CEP",
          description: "(Atenção! Esta opção pode reduzir a sua de conversão)"
        },
        {
          id: "pos_address_shopper",
          name: "Solicitar endereço do comprador após a compra",
          hide: true
        }
      ]
    };
  },
  methods: {
    submit() {
      const data = this.options.reduce((acc, option) => {
        acc[option.id] = this.values.includes(option.id);
        return acc;
      }, {});
      this.$emit("save", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.product-checkout-form-buy {
  .form-group {
    margin: 8px 0 0;
  }

  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }

  .text {
    color: #5a5466;
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
